<template>
  <div>
    <span class="ent-btntext" v-if="sendAuthCode" @click="handleSend">获取验证码</span>
    <span class="ent-disable-btntext" v-else>{{buttonText}}</span>
  </div>
</template>
<script>
import {
  isPhoneAvailable,
  getCookie,
  setCookie
} from '@/util/utils.js'

export default {
  name: 'getCode',
  props: {
    phonenum: String,
    type: String,
    imgcode: String,
    uuid: String
  },
  data () {
    return {
      buttonText: '60s 后重新获取',
      sendAuthCode: true,
      auth_time: 60,
      smsCode: '',
      pinToken: ''
    }
  },
  methods: {
    handleSend () {
      var isimgcodenull = this.imgcode === ''
      var isphonenumnull = this.phonenum === ''
      var isavailable = isPhoneAvailable(this.phonenum) || this.type === '15'
      if (isphonenumnull) {
        this.$emit('handleerror', '请输入手机号')
      } else {
        if (!isavailable) {
          this.$emit('handleerror', '手机号格式不正确')
        }
      }
      if (isavailable && !isphonenumnull) {
        if (isimgcodenull) {
          this.$emit('handleerror', '请输入图片验证码')
        }
      } else {
        isimgcodenull = false
      }
      if (isavailable && !isphonenumnull && !isimgcodenull) {
        this.countDown()
        this.$emit('handleerror', '')
      }
    },
    countDown () {
      var _this = this
      _this.auth_time = 60
      var nowTime = new Date().getTime()
      var countCooTime = getCookie('ENTWEBCOUNTTIME')
      if (countCooTime && nowTime - countCooTime <= 60000) {
        // var sec = 60 - parseInt((nowTime - countCooTime) / 1000)
        return false
      } else {
        let data = {
          uuid: this.uuid,
          code: this.imgcode,
          type: this.type,
          phoneNum: this.phonenum
        }
        this.$http({
          method: 'POST',
          baseURL: '',
          url: this.commonapi + '/sms/send',
          params: data
        }).then(function (res) {
          if (res.code === 100 || res.code === '100') {
            _this.$alert('短信发送成功，' + res.data.message, '成功', {
              type: 'success',
              confirmButtonText: '确定'
            })
            _this.pinToken = res.data.pinToken
            setCookie('ENTWEBCOUNTTIME', nowTime)
            var timer = setInterval(function () {
              if (_this.auth_time !== 0) {
                _this.auth_time--
                _this.buttonText = _this.auth_time + 's 后重新获取'
              } else {
                _this.sendAuthCode = true
                clearInterval(timer)
              }
            }, 1000)
            _this.sendAuthCode = false
          } else {
            if (res.msg) {
              _this.$emit('handleerror', res.msg, true)
            } else {
              _this.$alert(res.actionSheet.content || res.msg, '提示', {
                type: 'info',
                confirmButtonText: '确定'
              })
              _this.$emit('handleerror', '', true)
            }
          }
        }).catch(function (error) {
          console.log(error)
        })
      }
    }
  }
}
</script>

<style scoped>
.ent-btntext {
  color: #2178ec;
  cursor: pointer;
}
.ent-disable-btntext {
  color: #999;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/getMsgCode/getMsgCode.vue